export default "__VITE_ASSET__BlgptVhM__"